import React, { useRef, useState, useEffect } from 'react';

import { FavoritesSection } from 'components/grid';
import { useDispatch } from 'react-redux';
import { CreateRequestHeader } from 'components/grid';
import { MapSearch } from 'components/ui';
import { setRecordRequestProvider } from 'store/actions/recordRequest.action';
import { getContodianDetails } from 'store/actions/favouriteCustodians.action';
import { useNavigate } from 'hooks';

export const FavoriteProviders = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    localStorage.setItem('language', '');
  
    const onSelect = (provider: any) => {
      dispatch(
        getContodianDetails({ name: provider.name, id: provider.id }, false, custodian => {
          dispatch(setRecordRequestProvider({ ...custodian, selectedLocation: provider.selectedLocation }));
          navigate('/record-request/patient');
        }),
      );
    };
  
  return (
    <div className='row mb-5 px-md-5'>
       <FavoritesSection onClick={onSelect} isFormRequest={false} />
    </div >
  );
};